import { render } from "./TrustStrip.vue?vue&type=template&id=4a77a876&scoped=true"
import script from "./TrustStrip.vue?vue&type=script&lang=js"
export * from "./TrustStrip.vue?vue&type=script&lang=js"

import "./TrustStrip.vue?vue&type=style&index=0&id=4a77a876&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a77a876"]])

export default __exports__